import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from 'shared/services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class TokenLoginGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // This Guard should ONLY trigger on a /auth? path and not an /auth/something? path.
    // if (state.url.search(/^\/auth\/.*/) !== -1) {
    //   return true;
    // }
    const { token: tokenId } = route.queryParams;

    if (tokenId) {
      return this.authService.programmaticLogout().pipe(
        switchMap(() => this.authService.verifyToken({ token: tokenId })
          .pipe(
            switchMap(result => {

              if (result.payload) {
                // Temp solution to receive resident and facilityId from token
                const payload = JSON.parse(result.payload) as { username: string, token: string, target: string, payload?: { sessionId?: string } };
                const { token: challenge, username } = payload;
                const extra = payload.payload;
                return this.authService.customChallengeLogin({ tokenId, challenge, username, removeChallenge: false })
                  .pipe(
                    map(result => {
                      if (result.status === 'SUCCESS') {
                        console.log('target', payload.target)
                        if (payload.target === 'ORIENTATION') {
                          return this.router.parseUrl(`/orientation`);
                        }
                        if (payload.target === 'VIDEO_CALL' && extra?.sessionId) {
                          return this.router.parseUrl(`/lifestory?sessionId=${extra.sessionId}`);
                        }
                      }
                      // fallback for incorrect target
                      return this.router.parseUrl('/expired');
                    })
                  )
              }
              return of(this.router.parseUrl('/expired'))
            })
          )
        ))
    } else {
      return this.router.parseUrl('/error');
    }
  }
}